import CollectionFirstSec from "../PageElements/HomeCollectionPageElements/HomeCollectionFirstSection";
import SampleCollectionSection from "../PageElements/HomeCollectionPageElements/SampleCollectionSection";
import AppointmentSection from "../PageElements/HomeCollectionPageElements/AppointmentSection";
import WHSCSection from "../PageElements/HomeCollectionPageElements/WHSCSection";
import WhyChooseUsRBD from "../PageElements/HomeCollectionPageElements/WhyChooseUs";

import ServiceSection from "../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import HomeAppoinmentForm from "../PageElements/HomeCollectionPageElements/HomeAppoinmentForm";

export const HomeColleectionTest = () => {
  return (
    <>
      <CollectionFirstSec />
      {/* <AppointmentSection /> */}
      <HomeAppoinmentForm />
      <SampleCollectionSection />
      <WHSCSection />
      <WhyChooseUsRBD />
      {/* <ServiceSection /> */}
      {/* <ConsultSection /> */}
    </>
  );
};
